module.exports = __webpack_public_path__ + "static/img/beikang.6c5f5b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/phone/beikang.jpg
// module id = svpR
// module chunks = 1